var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconLanguageSquare = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", stroke: props.color, strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-42.534 -33.065)" },
                React.createElement("g", { transform: "translate(44.553 34.435)" },
                    React.createElement("line", { x1: "1", y1: "15.8", x2: "5.7", y2: "1.6" }),
                    React.createElement("line", { x1: "11", y1: "15.8", x2: "6.4", y2: "1.6" }),
                    React.createElement("line", { x1: "2", y1: "10.6", x2: "9.5", y2: "10.6" })),
                React.createElement("g", { id: "Gruppe_1233", transform: "translate(58.153 44.4)" },
                    React.createElement("path", { d: "M-1.1,16.3c0,0,1.8-0.8,2.4-4.3s0-11.5,0-11.5" }),
                    React.createElement("line", { x1: "1.2", y1: "0.5", x2: "11.2", y2: "0.5" }),
                    React.createElement("path", { d: "M11.2,0.5c0,0,0.1,7.2,0.1,11.1s-4.4,2.8-4.4,2.8" }),
                    React.createElement("line", { x1: "2.1", y1: "9.9", x2: "10.4", y2: "9.9" }),
                    React.createElement("line", { x1: "2.1", y1: "5.1", x2: "10.4", y2: "5.1" }))),
            React.createElement("path", { d: "M13.6,3h11.1c1.2,0,2.2,1,2.2,2.2V7" }),
            React.createElement("path", { d: "M3,21.9v3.5c0,1.2,1,2.3,2.3,2.3h4.1" }))));
});
export default IconLanguageSquare;
//# sourceMappingURL=IconLanguageSquare.js.map